import React, { useEffect, useState } from 'react';
import Dashboard from '../../core/Dashboard';
import GymFilter from '../../components/gym-filter';
import UserProfile from '../../components/user-profile';
import SlideSideBar from '../../components/sidebar/components/slide-side-bar';
import DeviceLogs from './components/device-logs';
import SearchFilter from '../../components/search-filter';
import './style.scss';
import { getBioMetricDevicesByBranch } from './helper/api';
import { isAuthenticated } from '../../auth';
import { formatDateAndTime, startLoader, stopLoader } from '../../lib/utils';
let timer;
const BiometricDevice = () => {

  const [selectedGym, setSelectedGym] = useState("");
  const [isSticky, setIsSticky] = useState(false);
  const [searchData, setSearchData] = useState("");
  const [logCount,setLogCount] = useState(0);
  const [devices, setDevices] = useState([
    // {
    //   deviceName:"Device 1",
    //   ip: "0.0.0.0:0000",
    //   isActive:true
    // },
    // {
    //   deviceName:"Device 2",
    //   ip: "0.0.0.0:0000",
    //   isActive:false
    // }
  ]);
  const {user,token} = isAuthenticated();

  const [selectedDevice,setSelectedDevice] = useState();

  const handleSelectDevice= (device) =>{
    if(selectedDevice && selectedDevice._id == device._id) setSelectedDevice('');
    else setSelectedDevice(device);
  }


  const handleSelectedGym = (gym) => {
    setSelectedGym(gym)
  }

  const handleSearchingData = () => {

  }

  const GetBioMetricDevicesByBranch = async () =>{
    try{
      const response = await getBioMetricDevicesByBranch(user._id,token,localStorage.getItem("branchId"));
      if(!response?.error) setDevices(response);
    }catch(error){

    }
  }

  const handleLogCount = (count) => setLogCount(count);


  useEffect(async ()=>{
    try{
      if(timer){
        clearInterval(timer)
        timer = undefined;
      }
      if(!timer){
        startLoader()
        await GetBioMetricDevicesByBranch();
        timer=setInterval(()=>{
            GetBioMetricDevicesByBranch()    
        },1000*30)
      }
    }catch(error){

    }
    stopLoader()
  },[localStorage.getItem("branchId")])

  return(
    <Dashboard flag={-1}>
      <div id="container" className="main-container main-container-auto">
        <div className="header-bar d-flex space-between" style={{padding:"0"}}>
          <div className='d-flex flex-item'>
            <svg className='flex-item m-r-8' width="56" height="56" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.0359 12.158C12.0359 12.158 11.0499 16.894 16.5279 19.151" stroke="var(--darkBlue)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M13.7517 20.9519C10.8807 19.3309 8.66571 16.2259 9.02671 12.8249C9.02969 12.1749 9.18907 11.5351 9.4914 10.9597C9.79373 10.3843 10.2301 9.8901 10.7637 9.51888C11.4498 9.17875 12.2417 9.12024 12.9703 9.35583C13.6989 9.59142 14.3066 10.1025 14.6637 10.7799C15.6057 12.1679 14.9387 13.9589 15.6277 15.4209C16.6877 17.2219 19.3777 16.7669 20.3947 15.1239C21.9207 12.7719 21.1097 9.18088 19.5517 7.01888C17.1047 3.68188 13.5087 1.91188 8.41171 3.68088C3.6227 5.31288 1.24971 12.0619 3.77171 16.5439" stroke="var(--darkBlue)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M7.98221 19.0018C7.11047 17.9929 6.47379 16.8029 6.11821 15.5178C5.76435 14.2369 5.70182 12.893 5.93521 11.5848C6.06679 10.7142 6.37658 9.88018 6.84521 9.1348C7.3168 8.38423 7.93476 7.73634 8.66221 7.2298C9.74173 6.5903 10.9876 6.2877 12.2402 6.3608C13.0512 6.3858 13.8502 6.5688 14.5892 6.8978C15.3282 7.2268 15.9952 7.6958 16.5492 8.2778C17.7549 9.85255 18.3553 11.8078 18.2412 13.7878" stroke="var(--darkBlue)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div className='flex-item m-l-6'>
              <p className="fs-26 font-weight-600 color-extra-dark-blue flex-item" style={{lineHeight:"26px"}}>Biometric</p>
              <p className="fs-12 cursor-pointer m-t-2">Manage your biometric logs here</p>
            </div>
          </div>
          <div className='d-flex flex-item'>
            {
              devices.map(d => {
                return(
                  <div onClick={()=>handleSelectDevice(d)} className='device-container d-flex m-r-12' style={{
                    backgroundColor: selectedDevice && selectedDevice._id == d._id && "#055075",cursor:'pointer'
                  }}>
                    <div className='flex-item'>
                      <div className='d-flex'>
                        <p className="flex-item fs-14 color-dark-blue font-weight-700" style={{lineHeight:"14px",color:selectedDevice && selectedDevice._id == d._id && "#fff"}}><span style={{textTransform:'capitalize'}}>{d.vendor}</span>-{d.serialNumber}</p>
                        <div className='flex-item status-dot m-l-8 m-b-2' style={{background: d?.status == 'online' ? "#46a200" : "#e33a34"}}/>
                      </div>
                      <p className='fs-12 font-weight-500 m-t-4' style={{color:selectedDevice && selectedDevice._id == d._id && "#fff"}}>Last Ping: {d.lastPing?formatDateAndTime(d.lastPing):'-'}</p>
                    </div>
                  </div>
                )
              })
            }
            <div className="flex-item">
              <GymFilter getSelectedGym={handleSelectedGym}/>
            </div>
            <UserProfile/>
            {
              window.innerWidth < 1250 && window.innerWidth > 767 && (
                <SlideSideBar/>
              )
            }
          </div>
        </div>

        {
          window.innerWidth > 767 && [
            <div className="dashboard-data-saperator m-t-16 flex-item" />,
            <SearchFilter count={logCount} searchType={"by Command"} isSticky={isSticky} isSearchEnabled={true} searchingData={handleSearchingData} isFilterEnabled={true} filterSection={"biometric-filter"} />
          ]
        }

        <div className='m-t-12' />

        <DeviceLogs handleLogCount={handleLogCount} selectedDevice={selectedDevice}/>

      </div>
    </Dashboard>
  )
}

export default BiometricDevice;